import React from "react";
import { Box, Typography } from "@mui/material";

const RelatorioEstoqueHeader = ({ empresa, data, sx }) => {

    const user = localStorage.getItem('user').replace(/"/g, '');

    return (
        <>
            <Box className='relatorio-header' sx={sx}>
                <Box>
                    <img src='/sistema/v10.png' alt='v10' className='relatorio-logo' />
                </Box>

                <Box>
                    <Typography className="relatorio-header-title">RELATÓRIO ESTOQUE PNEUS</Typography>
                </Box>

                <Box >
                    <Typography className="relatorio-header-title">  {empresa}</Typography>
                </Box>
            </Box>

            <Box className="relatorio-divisao" />

            <Box className="relatorio-box-header">
                <Box className="relatorio-box-header-impresso">
                    <Typography className="relatorio-box-header-title">Impresso por:</Typography>
                    <Typography className="relatorio-box-header-title-value">{user}</Typography>
                </Box>

                <Box className="relatorio-box-header-date">
                    <Typography className="relatorio-box-header-title">Data Impressão:</Typography>
                    <Typography className="relatorio-box-header-title-value">{data}</Typography>

                </Box>
            </Box>
        </>
    )
}

export default RelatorioEstoqueHeader;